export const RANGE_DEFAULT_META_FIELD = {
  MIN: 3,
  MAX: 99,
};
